module.exports = __webpack_public_path__ + "renault.fe23f8fb050d9edd4b07.png";